/**
 * Sum a numeric column across rows, by key (`sumBy(rows, 'amount')`) or by picker
 * (`sumBy(rows, r => r.amount / 100)`). Non-numeric and missing values count as 0,
 * so one null cannot turn the whole total into NaN.
 */
export const sumBy = <T,>(rows: T[], keyOrPick: keyof T | ((row: T) => number | null | undefined)): number =>
    rows.reduce((total, row) => {
        const value = typeof keyOrPick === 'function' ? keyOrPick(row) : row[keyOrPick];
        return total + (Number(value) || 0);
    }, 0);

/** Sum several columns in one pass — `{ fee: 120, aum: 4500 }`. */
export const sumKeys = <T, K extends keyof T>(rows: T[], keys: readonly K[]): Record<K, number> => {
    const totals = Object.fromEntries(keys.map(key => [key, 0])) as Record<K, number>;
    rows.forEach(row => {
        keys.forEach(key => { totals[key] += Number(row[key]) || 0; });
    });
    return totals;
};
